import React from 'react'

const Jalsrotraurja = () => {
  return (
    <div>
      <div>
        <h3>शब्दभण्डार</h3>
        <h5>१. दिइएका शब्द र अर्थ बीच जोडा मिलाउनुहोस् :</h5>
        <p>अथाह - ज्यादै धेरै</p>
        <p>नौका - डुङ्गा</p>
        <p>अलावा - अतिरिक्त</p>
        <p>अख्तियार - नियम कानुनद्वारा दिइएको अधिकार</p>
        <p>नित्य - सधैँ</p>
        <p>सर्वेक्षण - कुनै विषयको तथ्यपूर्ण जानकारीका लागि गरिने निरिक्षण</p>
        <p>निकाय - कुनै संस्था वा सदन</p>
      </div>
      <hr/>
      <div>
        <h5>२. मिना अयरको वक्तृता पढी दिइएको खाली ठाउँमा मिल्ने शब्द भर्नुहोस् :</h5>
        <p>(क) सम्पदाका</p>
        <p>(ख) हौस्याउने र अख्तियार</p>
        <p>(ग) नौका विहार</p>
        <p>(घ) चलायमान</p>
        <p>(ङ) जलस्रोतको</p>
      </div>
      <hr/>
      <div>
        <h5>३. दिइएको शब्दहरुको उल्टो अर्थ दिने शब्द पाठबाट खोजेर लेख्नुहोस् :</h5>
        <p>कृत्रिम : प्राकृतिक</p>
        <p>विपन्न : सम्पन्न</p>
        <p>प्राचीन : आधुनिक</p>
        <p>साँघुरो : फराकिलो</p>
        <p>आन्तरिक : बाह्य</p>
        <p>सङ्कुचन : बिस्तार</p>
        <p>कुरुप : सुन्दर</p>
        <p>सदुपयोग : दुरुपयोग</p>
        <p>व्यय : आय</p>
        <p>अटुट : अटल</p>
        <p>विष : अमृत</p>
        
      </div>
      <hr/>
      <div>
        <h5>४. दिइएका शब्दहरुको अर्थ खुल्ने गरी वाक्यमा प्रयोग गर्नुहोस् :</h5>
        <strong>मञ्चासीन</strong>
        <p>प्रमुख अतिथि कार्यक्रमको सुरुवातमा मञ्चासीन भए।</p>
        <strong>द्रुततर</strong>
        <p>प्रविधिको विकास अघिल्लो दशकको तुलनामा अहिले द्रुततर भएको छ।</p>
        <strong>सामर्थ्य</strong>
        <p>उसले कठिन परिस्थितिमा पनि काम गर्न सक्ने सामर्थ्य देखायो।</p>
        <strong>खपत</strong>
        <p>गर्मीको मौसममा विजुलीको खपत अत्यधिक हुन्छ।</p>
        <strong>पैनी</strong>
        <p>प्रहरीको पैनी नजरबाट अपराधी उम्कन सकेन।</p>
        <strong>उर्वरा</strong>
        <p>चितवनको उर्वरा भूमिमा धानको राम्रो उत्पादन हुन्छ।</p>
        <strong>अभियान</strong>
        <p>सरकारले सरसफाइ अभियान सञ्चालन गरेको छ।</p>
        <strong>सङ्कट</strong>
        <p>कोरोनाको महामारीले विश्वलाई ठूलो सङ्कटमा पार्‍यो।</p>
        <strong>गगनचुम्बी</strong>
        <p>काठमाडौंमा धेरै गगनचुम्बी भवनहरू बन्न थालेका छन्।</p>
        <strong>अन्नामृत</strong>
        <p>किसानले मेहनत गरेर उब्जाएको अन्न नै हाम्रो अन्नामृत हो।</p>
        <strong>निर्यात</strong>
        <p>नेपालले फलफूल र जडीबुटी भारतमा निर्यात गर्छ।</p>
      </div>
      <hr/>
      <div>
        <h5>५. तल दिइएका पदावलीहरु प्रयोग गरी अनुच्छेद लेख्नुहोस् :</h5>
        <p>प्रकृतिको सुन्दरताले भरिपूर्ण भएको हाम्रो देश नेपाल सानो छ तर यहाँ स्वर्गको अनुभव हुन्छ । खोलानाला, पहाड, वन, जङ्गल, वन्यजन्तु आदिका कारण यो देश <strong>पर्यटकीय गन्तव्य</strong> बन्न पुगेको छ । यसलाई हामीले <strong>देशोन्नतिको सिँढी</strong> बनाउनु पर्छ । यहाको <strong>सेतो सुन</strong>, पानी, <strong>कृषिजन्य उत्पादन</strong> र पर्यटन व्यवसायलाई विकास गर्न सके देशको छिट्टै काँचुली फेर्ने थियो । यहाँ एक पटक आएर <strong>प्रकृतिको छ्टालाई</strong> नियाल्ने पर्यटक फेरि आउन चाहन्छ । <strong>फेवाको फैलावट, राराको रमिता, गण्डकीको गहिराइ र चमत्कारी पानीले</strong> हाम्रो <strong>सम्पन्नताको ढोका</strong> खोल्दै छ । त्यसैले अब हामीले आफ्नो बारेमा होइन देशको बारेमा सोच्नुपर्छ ।</p>
      </div>
      <hr/>
      <div>
        <h3>बोध र अभिव्यक्ति</h3>
        <h5>१. 'जलस्रोत र ऊर्जा ' पाठ पढी दिइएका प्रश्नहरुको उत्तर दिनुहोस् :</h5>
        <h5>(क) पहिलो वक्ता र दोस्रो वक्ताले कति कति अनुच्छेदमा आफ्नो प्रस्तुति राखेका छन् ?</h5>
        <p>= पहिलो वक्ताले छ अनुच्छेदमा र दोस्रो वक्ताले आठ अनुच्छेदमा आफ्नो प्रस्तुति राखेका छन् ।</p>
        <h5>(ख) वक्तृता सन्चालनको विधिलाई पाठमा कसरी प्रस्तुत गरेको छ ?</h5>
        <p>= विद्यालयका प्रधानाध्यापकलाई कार्यक्रमको अध्यक्ष, तीन जना शिक्षकहरु निर्णायक, एक जना शिक्षक समय पालक, एक जना विद्यार्थी कार्यक्रम अनि प्रतियोगी राखेर क्रमशः प्रतियोगी विद्यार्थीहरुलाई उद्घोषकले बोलाएर आफ्नो वक्तृता प्रस्तुत गर्ने, अन्त्यमा निर्णायकले निर्णय सुनाउने र अध्यक्षले पुरस्कृत विद्यार्थीहरुलाई पुरस्कार वितरण गरी कार्यक्रम टुङ्याउने विधिलाई पाठमा प्रस्तुत गरिएको छ ।</p>
        <h5>(ग) पहिलो वक्ताले जलस्रोतसम्बन्धी कुन कुन सन्दर्भलाई समेटेको छ ?</h5>
        <p>= पहिलो वक्ताले जलस्रोतमा हिमाल, समुन्द्र, नदीनाला, झरना, तालतलैया, आफै पानी निस्कने मूलहरु, इनार, ट्युबवेल तथा वर्पादलाई समेटेको छ ।</p>
        <h5>(घ) दुवै वक्ताले वक्तृताका समापन कसरी गरेका छन् ?</h5>
        <p>= पहिलो वक्ताले सेतो सुनका रुपमा परिचित पानीलाई हामीले सही सदुपयोग गरेमा नेपालेको विकास गर्न सकिन्छ भनी वक्तृता समापन गरेका छन् भने दोस्रो वक्ताले जलस्रोतलाई सदुपयोग गर्न सके हामीले बेरोजगार हुनुपर्ने छैन भनी वक्तृता समापन गरेका छन् ।</p>
        <h5>(ङ) नेपालमा उपलब्ध जकस्रोत के के हुन् ?</h5>
        <p>= नेपालमा उपलब्ध जलस्रोतहरु हिमाल, नदीनाला, झरना, तालतलैया, आफै पानी निस्कने मूलहरु, इनार, ट्युबवेल, तथा वर्पाद आदि हुन् ।</p>
      </div>
      <hr/>
      <div>
        <h5>२. `नेपालमा जलस्रोतको ……..वातावरण तयार गर्नुपर्छ´वक्तृतांश पढी सोधिएका प्रश्नहरुको उत्तर दिनुहोस्:</h5>
        <h5>(क) नेपाली जलराशिमा कति मेगावाट विद्युत् उत्पादन गर्ने क्षमता छ ?</h5>
        <p>= नेपाली जलराशिमा ८३ मेगावाट भन्दा बढी विद्युत् उत्पादन गर्ने क्षमता छ ।</p>
        <h5>(ख) के गर्न सके देशको आर्थिक समृद्धि हुने सम्भावना छ ?</h5>
        <p>= देशमा भएको जलस्रोतको सम्पूर्ण क्षमताको पचास प्रतिशत मात्रै विद्धुत उत्पादन गर्न सके देशको आर्थिक समृद्धि हुने सम्भावना छ ।</p>
        <h5>(ग) विद्युतको खपत कसरी बढाउन सकिन्छ ?</h5>
        <p>= राज्यले जलविद्युतसँग सम्बद्ध उद्योग, कलकारखानाहरु खोल्ने वातावरण बनाउने, घरायसी रुपकै विद्युतको खपत बढाउन हौस्याउने नीति अख्तियार गर्ने र आफ्नो देशमा उत्पादित विद्युत विदेश पुर्‍याउन सके विद्युतको खपत बढाउन सकिन्छ ।</p>
        <h5>(घ) जल विद्युतीकरणका लागि नेपालको भूगोल किन उपयुक्त मानिएको छ ?</h5>
        <p>= बाह्रै महिना परिरहने हिउँ नित्यनिरन्तर बगिरहने अथाह जलराशि र भिरालो भौगोलिक बनोटका कारण जल विद्युतीकरणका लागि नेपालको भूगोल उपयुक्त मानिएको छ ।</p>
      </div>
      <hr/>
      <div>
        <h5>३. दिइएको वक्तृतांश पढी सोधिएका प्रश्नहरुको उत्तर दिनुहोस्:</h5>
        <h5>(क) जलस्रोत र ऊर्जाका क्षेत्रमा दिगो विकास कसरी गर्न सकिन्छ ?</h5>
        <p>= जलस्रोत र ऊर्जाका क्षेत्रमा दिगो पूर्वाधार विकासका नीति, नीयम तथा योजनाहरु निर्माण गरी विदेसिने युवा शक्तिलाई प्रयोग गरेर कार्यान्वयन गर्नुपर्छ । राज्यले जलविद्युतसँग सम्बद्ध उद्योग, कलकारखानाहरु खोल्ने वातावरण बनाउने, घरायसी रुपकै विद्युतको खपत बढाउन हौस्याउने नीति अख्तियार गर्ने र आफ्नो देशमा उत्पादित विद्युत विदेश पुर्‍याउन सके जलस्रोत र ऊर्जाका क्षेत्रमा दिगो विकास गर्न सकिन्छ ।</p>
        <h5>(ख) राष्ट्रको अर्थतन्त्र निर्माणमा सिँचाइको कस्तो भुमिका हुन्छ ?</h5>
        <p>= राष्ट्रको अर्थतन्त्र निर्माणमा सिँचाइको महत्त्वपूर्ण भुमिका हुन्छ । नेपालमा स्तित ६ सय भन्दा बढी नदीहरु बाह्रै महिना निरन्तर बगिरहन्छन् । यिनै नदीनालाहरुलाई कुलो, पैनी वा नहर निर्माण गरेर भूमिमा पर्याप्त सिँचाइ पुर्‍याउन सके राष्ट्रले खाद्यान्नमा परिनिर्भर हुनुपर्दैन । सिँचाइको उचित व्यवस्थापन गरेर धर्तीको उर्वराशक्ति बढाई प्रशस्त खाद्यान्न उत्पादन गरी विदेशमा निर्यात गरी वैदेशिक मुद्रा आर्जन गरी राष्ट्रिय अर्थतन्त्रलाई बलियो बनाउन सक्छौं । सिँचाइलाई आधुनिक र प्रविधिमैत्री बनाउन सकेमा खाद्यान्नमा आत्मनिर्भर हुन सक्छौं । रोजगारका अवसरहरु सिर्जना हुन्छन् अनि राजस्वमा वृद्धि हुन्छ । तसर्थ सम्पूर्ण उर्वर भूमिलाई सिचाइ पुर्‍याउन सकेमा राष्ट्रको अर्थतन्त्र दह्रो हुनेछ ।</p>
      </div>
      <hr/>
      <div>
        <h5>४. `जलस्रोत र ऊर्जा ´विषयक वक्तृताका दुवै वक्ताहरुले आफ्नो वक्तृतालाई प्रभावकारी बनाउन के कस्ता सहायक तर्क वा तथ्यहरु पेस गरेका छन्, दुवैको वक्तृताबाट कम्तिमा तीन तीनवटा बुँदाहरु टुप्नुहोस् :</h5>
        <strong>पहिलो वक्ताका सहायक बुँदाहरू:</strong>
        <p>1. नेपालमा सिंचाइको राम्रो व्यवस्था गरी प्रशस्त खाद्यान्न उत्पादन गर्न सकिने र विदेश गएका युवालाई स्वदेशमै रोजगारी दिन सकिने।</p>
        <p>2. नेपालमा समुन्द्रबाहेक सबै प्रकारका जलस्रोतहरू उपलब्ध छन्, जसको सही उपयोग गरेमा राज्यको समृद्धि सम्भव छ।</p>
        <p>3. नेपालसँग ८३ हजार मेगावाट जलविद्युत उत्पादन गर्ने सम्भावना छ, जसले ऊर्जा क्षेत्रमा आत्मनिर्भरता ल्याउन सक्नेछ।</p>
        <strong>दोस्रो वक्ताका सहायक बुँदाहरू:</strong>
        <p>1. नेपालमा पाइने स्वच्छ र कञ्चन पानीलाई अन्तर्राष्ट्रिय बजारमा बिक्री गरी देशलाई आर्थिक रूपले सम्पन्न बनाउन सकिन्छ।</p>
        <p>2. कृषियोग्य भूमिमा सिंचाइको व्यवस्था गरेमा कृषि उत्पादन बढ्ने र त्यसले अर्थतन्त्रको मुहार फेर्न सक्ने।</p>
        <p>3. जलस्रोतको प्रयोगबाट कलकारखाना तथा उद्योगको विकास गर्न सकिने र देशको औद्योगिक प्रगति सम्भव हुने।</p>
      </div>
      <hr/>
      <div>
        <h5>५. माथिको `जलस्रोत र ऊर्जा ´वक्तृता विषय पढी त्यसमा अपुग विषयहरु के के हुन्, कक्षामा छलफल गरी लेख्नुहोस्:</h5>
        <p>= जूलसीत र उर्जा वक्तृता विषयका अपुग विषयहरू निम्न अनुसार छन्:</p>
        <p>(क) नेपालबाट दिनहुँ हजारौँ युवाहरू वैदेशिक रोजगारका लागि जानुपरेको स्थितिमा, सरकारले अनुसन्धन, तालिम, लगानीको अवसर प्रदान गरी तिनै युवालाई जलस्रोत तथा ऊर्जा क्षेत्रमै रोजगारी दिन प्रोत्साहन गर्नुपर्ने विषय वक्तृत्वामा समेटिएको थिएन।</p>
        <p>(ख) जलस्रोत र ऊर्जा जस्ता विषय प्राकृतिक स्रोत–साधनसँग प्रत्यक्ष सम्बन्धित भएकाले, सरकारी नीति, वातावरण संरक्षण, र दीर्घकालीन योजना जस्ता पक्षमा पनि स्पष्ट तर्क प्रस्तुत गरिएको थिएन।</p>
        <p>(ग) स्थानिय, सामुदायिक र जनस्तरको सहभागिता, जस्तै नेपाली जनशक्तिको सीधा संलग्नता, ऊर्जा उत्पादन, संरक्षण तथा व्यवस्थापनमा नैतिक, व्यवहारिक र शैक्षिक तहबाट कसरी जोड्ने भन्ने पक्ष समेत छुटेको छ।</p>
      </div>
      <hr/>
      <div>
        <h5>६. नेपालको जलस्रोतले देशको समृद्धिको आधार कसरी तयार पार्छ, लेख्नुहोस् ।</h5>
        <p>= नेपालमा रहेको जलस्रोत देशको प्रमुख प्राकृतिक सम्पत्ति हो। यहाँ साना–ठूला गरी ६ हजारभन्दा बढी नदीहरू छन्, जसमा ६ सयभन्दा बढी नदीहरू वर्षभरि बगिरहन्छन्। यी नदीहरूबाट ८३ हजार मेगावाटभन्दा बढी जलविद्युत् उत्पादन गर्न सकिने क्षमता छ। यदि सरकारले यस जलस्रोतको ५०% मात्र पनि सदुपयोग गर्न सक्यो भने देशको आर्थिक विकासमा उल्लेखनीय गति ल्याउन सकिन्छ।</p>
        <p>नेपालको जलस्रोतले ऊर्जा उत्पादन, सिंचाइ सुविधा, रोजगारी सिर्जना र निर्यात गरी मुलुकको आर्थिक आधार बलियो बनाउने महत्त्वपूर्ण सम्भावना राख्छ। जलविद्युतको उत्पादनलाई घरेलु उपभोगसँगै विदेशी बजारमा निर्यात गर्न सकेमा राजस्व वृद्धि र विदेशी मुद्रा आर्जन हुन सक्छ।</p>
        <p>त्यसैगरी, जलस्रोतको माध्यमबाट कुलो, नहर, पैनी निर्माण गरेर खेतीयोग्य जमिनमा सिँचाइ सुविधा पु-याउन सकिन्छ। यसले उर्वराशक्ति बढाउने, प्रशस्त खाद्यान्न उत्पादन गर्ने, विदेशमा निर्यात गर्ने र रोजगारी सिर्जना गर्ने जस्ता अवसर प्रदान गर्दछ। सिँचाइलाई आधुनिक प्रविधिसँग जोड्न सकेमा खाद्यान्नमा आत्मनिर्भर बन्न सकिन्छ।</p>
        <p>अन्ततः जलस्रोतसँग सम्बन्धित उद्योग, कलकारखाना, ऊर्जा नीति, निर्यात योजना तथा पूर्वाधार विकासमा राज्यले प्राथमिकता दिएमा नेपाल जलस्रोतको माध्यमबाट दिगो विकास र समृद्धि हासिल गर्न सक्ने छ।</p>
      </div>
      <hr/>
      <div>
        <h5>१०. दिइएका गद्यांश पढी सोधिएका प्रश्नहरुको उत्तर दिनुहोस् :</h5>
        <h5>(क) संविधानलाई किन देशको मूल कानुन भनिएको हो ?</h5>
        <p>= राजनीतिक तथा नागरिक अधिकार एवम् सामाजिक सांस्कृतिक अधिकारलाई नि:सृत गर्ने मानव अधिकारका मूलभूत मान्यताहरुलाई अङ्गीकार गर्ने हुनाले संविधानलाई देशको मूल कानुन भनिएको हो ।</p>
        <h5>(ख) सबैके कानुनको परिपालना नगरे के हुन्छ ?</h5>
        <p>= कुनै पनि व्यक्ति, संग्संस्था तथा अरु कसैले पनि कानुन पालना नगरे एक आदर्श, समृद्ध सभ्य, अनुशासित र मर्यादित समाज निर्माण गर्न सकिदैन ।</p>
        <h5>(ग) अध्यादेशबाट निर्मित कानुन संसद बैठकबाट किन अनुमोदन गराउनुपर्छ ?</h5>
        <p>= आवश्यक परेमा संसद नबसेको बेलामा नेपाल सरकारले देवानी र फौजदारी कानुन अध्यादेशमार्फत निर्माण गर्न सकिन्छ र त्यसलाई कानुनी मान्यता दिनको लागि संसद बैठकबाट अनुमोदन गराउनुपर्छ ।</p>
        <h5>(घ) `सङ्घीय संसद´ र `अध्यादेश´ को अर्थ लेख्नुहोस् ।</h5>
        <p>= सङ्घीय संसद : लोकतान्त्रिक तथा प्रजातान्त्रिक मुलुकहरुमा जनताद्वारा निर्वाचित सर्वोच्च संस्था ।
अध्यादेश : संसदको अधिवेशन नभएको बेला खास समयका निम्ति आवश्यक परेमा राष्ट्रको सर्वोच्च संस्थाबाट विशेष अधिकारको प्रयोग गरी जारी भएको आदेश ।</p>
      </div>
      <hr/>
      <div>
        <h3>व्याकरण</h3>
        <h5>१. दिइएका वाक्यबाट उद्देश्य र विधेय भाग छुट्याउनुहोस् :</h5>
        <p>(क) उद्देश्य : युवाशक्ति</p>
        <p>विधेय : छन्</p>
        <p>(ख) उद्देश्य : जल</p>
        <p>विधेय : हुन्छन्</p>
        <p>(ग) उद्देश्य : बेरोजगारहरु</p>
        <p>विधेय : आउने छन्</p>
        <p>(घ) उद्देश्य : अन्य वक्ता</p>
        <p>विधेय : राख्नुहुन्छ</p>
        <p>(ङ) उद्देश्य : प्रधानाध्यापक</p>
        <p>विधेय : टुङ्याउनुहुन्छ</p>
      </div>
      <hr/>
      <div>
        <h5>२. दिइएका वाक्यबाट उद्देश्य र उद्देश्य विस्तार, विधेय र विधेय विस्तार खण्ड छुट्याएर देखाउनुहोस् :</h5>
        <p>(क) उद्देश्य : बहिनी</p>
        <p>उद्देश्य विस्तार : उसकी</p>
        <p>विधेय : बस्दिनन्</p>
        <p>विधेय विस्तार : निर्वाचन समितिमा</p>
        <p>(ख) उद्देश्य : ऊ</p>
        <p>उद्देश्य विस्तार : धेरै दिनपछि मनलाई दरो पारी</p>
        <p>विधेय : गई</p>
        <p>विधेय : आँगनतिर</p>
        <p>(ग) उद्देश्य : मान्छे</p>
        <p>उद्देश्य विस्तार : आज बिहान हिडेको</p>
        <p>विधेय : पुगेछ</p>
        <p>विधेय विस्तार : छिटै नै दार्चुला</p>
        <p>(घ) उद्देश्य : तिम्रो पहिरन</p>
        <p>उद्देश्य विस्तार : गाउँमा</p>
        <p>विधेय : देखिन्छ</p>
        <p>विधेय विस्तार : गजबको</p>
      </div>
      <hr/>
      <div>
        <h3>व्याकरण कोटि</h3>
        <h5>१. दिइएको अनुच्छेदका वाक्यहरुको लिङ्ग परिवर्तन गर्नुहोस् :</h5>
        <p>= मेरी बहिनी विद्यालय गई । मेरो भाइ पनि विद्यालय गयो । बहिनी सरासर कक्षामा पसी । भाइ चाहिँ बाटामा साथीसँग कुराकानी गर्न थाल्यो । भान्जीले बाटोमै भाइलाई भेटिन् । बुबाले पनि भाइलाई बाटोमै भेट्नुभयो ।</p>
      </div>
      <hr/>
      <div>
        <h5>२. दिइएका वाक्यलाई कोष्ठमा बताएअनुसार परिवर्तन गर्नुहोस :</h5>
        <strong>(क) जेठो छोरो आउँदै छ । ( स्त्रीलिङ्ग )</strong>
        <p>= जेठी छोरी आउँदै छे ।</p>
        <strong>(ख) उसकी बहिनी घरमा बसेकी छे । ( पुलिङ्ग )</strong>
        <p>= उसको भाइ घरमा बसेको छ ।</p>
        <strong>(ग) तिम्रा छोराहरु असल छन् । ( स्त्रीलिङ्ग )</strong>
        <p>= तिम्री छोरीहरु असल छन् ।</p>
        <strong>(घ) सानी नानी पानी भर्छिन् । ( पुलिङ्ग )</strong>
        <p>= सानो बाबू पानी भर्छन् ।</p>
      </div>
      <hr/>
      <div>
        <h5>३. दिइएको अनुच्छेदका वाक्यहरुको वचन परिवर्तन गर्नुहोस् :</h5>
        <p>हामीले गाउँमा हाम्रा पुराना साथीहरु भेट्यौँ । मैले धेरैबेर कुरा गरेँ । साथीहरुले आफ्ना प्रगतिका कथा सुनाए । तिमीहरु पनि एकछिनमा आइपुग्यौ । उनीहरुले तिमीहरुलाई चिनेनन् । तिमीले उसलाई बिर्सिएछौ ।</p>
      </div>
      <hr/>
      <div>
        <h5>४. दिइएका वाक्यहरुलाई कोष्ठकमा बताएअनुसार परिवर्तन गर्नुहोस् :</h5>
        <strong>(क) सानो छोरो रोयो । ( बहुवचन )</strong>
        <p>= साना छोराहरु रोए ।</p>
        <strong>(ख) तिम्रा बहिनीहरु खेल्छन् । ( एकवचन )</strong>
        <p>= तिम्री बहिनी खेल्छिन् ।</p>
        <strong>(ग) त्यो फूल ओइलियो । ( बहुवचन )</strong>
        <p>= ती फूलहरु ओइलिए ।</p>
        <strong>(घ) असल मान्छेहरु नम्र हुन्छन् । ( एकवचन )</strong>
        <p>= असल मान्छे नम्र हुन्छ ।</p>
      </div>
      <hr/>
      <div>
        <h5>५. दिइएका वाक्यहरुलाई कोष्ठकमा बताएअनुसार परिवर्तन गर्नुहोस् :</h5>
        <strong>(क) हामीले सर्प र बिच्छी देखेका छौँ । ( तृतीय पुरुष )</strong>
        <p>= उनीहरुले सर्प र बिच्छी देखेका छन् ।</p>
        <strong>(ख) हजुर किन हास्नुभयो ? ( प्रथम पुरुष )</strong>
        <p>= म किन हाँसे ?</p>
        <strong>(ग) उहाँ राम्ररी बोल्नुहुन्छ । ( प्रथम पुरुष )</strong>
        <p>= म राम्ररी बोल्छु ।</p>
        <strong>(घ) हामी ज्यादै दु:खी छौँ । ( द्वितीय र तृतीय पुरुष )</strong>
        <p>= तिमीहरु ज्यादै दु:खी छौँ ।</p>
        <p>= उनीहरु ज्यादै दु:खी छन् ।</p>
        <strong>(ङ) तिमीहरु होहल्ला गर्दै छौ । ( तृतीय र प्रथम पुरुष )</strong>
        <p>= उनीहरु होहल्ला गर्दै छन् ।</p>
        <p>= हामी होहल्ला गर्दै छौ ।</p>
      </div>
      <hr/>
      <div>
        <h5>६. कोष्ठकमा बताएअनुसार परिवर्तन गर्नुहोस् :</h5>
        <strong>(क) तँ भात खान्छस् । ( उच्च आदरार्थी )</strong>
        <p>= हजुर भात खानुहुन्छ ।</p>
        <strong></strong>
        <strong>(ख) हजुर कहिले फर्किनुहुन्छ ? ( सामान्य आदरार्थी )</strong>
        <strong></strong>
        <p>= तिमी कहिले फर्किन्छौ ।</p>
        <strong>(ग) तिमी सबैलाई चिन्छौ । ( उच्च आदरार्थी )</strong>
        <p>= हजुर सबैलाई चिन्नुहुन्छ ।</p>
        <strong>(घ) ऊ प्रथम हुन्छ । ( मध्यम आदरार्थी )</strong>
        <p>= उनी प्रथम हुन्छिन् ।</p>
        <strong>(ङ) धनीलाल गाउँमा बस्छ । ( उच्च आदरार्थी )</strong>
        <p>= धनीलाल गाउँमा बस्नुहुन्छ ।</p>
      </div>
      <hr/>
      <div>
        <h5>७. दिइएको अनुच्छेदका वाक्यहरुलाई करण भए अकरणमा र अकरण भए करणमा बदल्नुहोस् :</h5> 
        <p>उनीहरु प्रदशनीमा गएनन् । हामी चाहिँ गयौ । तिमीहरु पनि गएछौ नि । उनीहरु कुनै पनि स्थलहरुको भ्रमण गरेनछ्न् । हामी त त्यत्तिकै बसेनौ । नयाँ नयाँ कुराहरु देख्यौ ।</p>
      </div>
      <hr/>
      <div>
        <h5>८. कोष्ठकमा बताएअनुसार परिवर्तन गर्नुहोस् :</h5>
        <strong>(क) उनीहरु धेरै राम्रा छन् । ( अकरण )</strong>
        <p>= उनीहरु कति पनि राम्रा छैनन् ।</p>
        <strong>(ख) तिमी कहिल्यै नराम्रो बोल्दैनौ । ( करण )</strong>
        <p>= तिमी सधै राम्रो छौ ।</p>
        <strong>(ग) आज धेरै जाडो होला जस्तो छ । ( अकरण )</strong>
        <p>= आज कति पनि जाडो होला जस्तो छैन ।</p>
        <strong>(घ) पानी परेन र जाडो भएन । ( करण )</strong>
        <p>= पानी पर्‍यो र जाडो भयो ।</p>
        <strong>(ङ) उसले चिनेको मान्छे बाटामा भेट्यो । ( अकरण )</strong>
        <p>= उसले चिनेको मान्छे बाटामा भेटेन ।</p>
      </div>
      <hr/>
      <div>
        <h5>९. कोष्ठका सहायताले तलका वाक्यहरु (काल, पक्ष, भाव, वाच्य र प्रेरणार्थ ) परिवर्तन गर्नुहोस् :</h5>
        <strong>(क)म घरमै बस्छु । ( सामान्य भूत)</strong>
        <p>= म घरमै बसेँ ।</p>
        <strong>(ख) हामी चिठी लेख्छौ । (अपूर्ण भूत)</strong>
        <p>= हामी चिठी लेख्दै थियौँ ।</p>
        <strong>(ग) तँ त्यही बस्छस् । (पूर्ण भूत )</strong>
        <p>= तँ त्यही बसेको थिइस् ।</p>
        <strong>(घ) तिमीहरु गृहकार्य गर्छौ ।(अभ्यस्त भूत)</strong>
        <p>= तिमीहरु गृहकार्य गर्थ्यौ ।</p>
        <strong>(ङ) तपाईं पोखरा जानुहुन्छ । (अज्ञात भूत )</strong>
        <p>तपाईं पोखरा जानुभएछ ।</p>
        <strong>(च) उनीहरु बजार गएछ्न् । (सामान्य वर्तमान)</strong>
        <p>= उनीहरु बजार जान्छन् ।</p>
        <strong>(छ)तिमी सधै डुल्थ्यौ । (अपूर्ण वर्तमान)</strong>
        <p>= तिमी सधै डुल्दै छौँ ।</p>
        <strong>(ज) नरेशले रुख ढाल्यो ।(पूर्ण वर्तमान)</strong>
        <p>= नरेशले रुख ढालेको छ ।</p>
        <strong>(झ) उहाँहरु यहाँ आउनुभयो । (सामान्य भविष्यत)</strong>
        <p>= उहाँहरु यहाँ आउनुहुनेछ ।</p>
        <strong>(ञ) उनी गट्टा खेल्थिन् । (अपूर्ण भविष्यत्)</strong>
        <p>= उनी गट्टा खेल्दै हुनेछिन् ।</p>
        <strong>(ट) सानी पाठ पढ्थिन् । (पूर्ण भविष्यत् )</strong>
        <p>= सानीले पाठ पढेकी हुनेछिन् ।</p>
        <strong>(ठ) उनीहरु खेल खेल्छन् । (सम्भावनाअर्थ)</strong>
        <p>= उनीहरु खेल खेल्लान् ।</p>
        <strong>(ड) तिमीहरु बजार गयौ । (आज्ञार्थ)</strong>
        <p>= तिमीहरु बजार जाओ ।</p>
        <strong>(ढ) तपाईं मिठाई खानुहोला । (अनुरोधार्थ)</strong>
        <p>= तपाईं मिठाई खाइदिनुहोस् ।</p>
        <strong>(ण) तँ फुटबल खेल्छस् । (इच्छार्थ)</strong>
        <p>= तैले फुटबल खेलेस् ।</p>
        <strong>(त) भाइहरु मेहनत गर्छन् । (प्रश्नार्थ)</strong>
        <p>= भाइहरु मेहनत गर्छन् ?</p>
        <strong>(थ) मैले पर्यटकहरु देखे । (कर्मवाच्य)</strong>
        <p>= मद्वारा पर्यटकहरु देखिय ।</p>
        <strong>(द) उनीहरु यतैतिर आऊन् । (भाववाच्य)</strong>
        <p>= (उनीहरु )यतैतिर आइयोस् ।</p>
        <strong>(ध) उनीहरुले घर बनाएका छन् ।(कर्मवाच्य)</strong>
        <p>= उनीहरुद्वारा घर बनाइएको छ ।</p>
        <strong>(न) तिमी कथाहरु पढौला । (प्रेरणार्थ)</strong>
        <p>= शिक्षकले तिमीलाई कथाहरु पढाउनुहोला ।</p>
        <strong>(प) ऊ घरमै बसोस् । (प्रेरणार्थ)</strong>
        <p>= आमा उसलाई घरमै बसाउनुहोस् ।</p>
        <strong>(फ) गुरुले तिमीलाई के के पढाउनु भएको छ ? (अप्रेरणार्थ)</strong>
        <p>= तिमीले के के पढेका छौ ।</p>
      </div>
      <hr/>
      <div>
        <h3>उक्ति</h3>
        <h5>१. दिइएका कथनहरु प्रत्यक्ष वा अप्रत्यक्ष के हुन् छुट्याउनुहोस् :</h5>
        <p>(क) प्रत्यक्ष कथन</p>
        <p>(ख) अप्रत्यक्ष कथन</p>
        <p>(ग) प्रत्यक्ष कथन</p>
        <p>(घ) अप्रत्यक्ष कथन</p>
        <p>(ङ) अप्रत्यक्ष कथन</p>
        <p>(च) प्रत्यक्ष कथन</p>
        </div>
        <hr/>
        <div>
          <h5>२. दिइएका वाक्यहरुलाई अप्रत्यक्ष कथनमा बदल्नुहोस् :</h5>
          <p>(क) समाजको अवस्था दयनीय छ भनी पूर्णमानले बतायो ।</p>
          <p>(ख) सन्तोषले गम्भीर हुँदै नेपालमा विकासको नयाँ परिभाषा चाहिएको छ, भन्यो ।</p>
          <p>(ग) परिभाषा बदल्दैमा समाजको समस्या समाधान हुँदोरहेनछ भनी सन्जीवले चिन्ता व्यक्त गर्‍यो ।</p>
          <p>(घ) उत्तर; समाज परिवर्तनका लागि आफू पनि खट्ने कुरा विमलाले उत्साहका साथ व्यक्त गरीन् ।</p>
          </div>
          <hr/>
          <div>
            <h5>३. दिइएको अनुच्छेदलाई प्रत्यक्ष कथनमा बदल्नुहोस् :</h5>
            <p>= आमाले छोरीलाई भन्नुभयो, “के गर्दैछ्यौ ?” छोरीले भनिन्, ” वक्तृताका लागि सामग्री सङ्कलन गरिरहेको छु ।” आमाले भन्नुभयो, ” म पनि वक्तृताको विषयमा चासो राख्छु ।” छोरीले आमालाई भनिन्, ” नेपालको सिँचाइ स्थिति कस्तो छ ।”</p>
            </div>
    </div>
  )
}

export default Jalsrotraurja
